import React from 'react';
import ApexNavbar from '../components/apex/ApexNavbar';
import ApexFooter from '../components/apex/ApexFooter';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <ApexNavbar />
      <main className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl sm:text-5xl font-bold text-white mb-4 tracking-tight" data-testid="terms-heading">
            Terms of Service
          </h1>
          <p className="text-[#71717A] mb-10">Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>

          <div className="space-y-10 text-[#A1A1AA] leading-relaxed">
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">1. Acceptance of Terms</h2>
              <p>By accessing and using this website, you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our website or services.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">2. Services</h2>
              <p>We provide fitness sales coaching, consultation services, sales process audits, and related professional services for small group PT and boutique gyms. The specific scope of services will be outlined in individual agreements or proposals provided to clients.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">3. Use of Website</h2>
              <p className="mb-3">You agree to use this website only for lawful purposes and in a way that does not infringe upon the rights of others. You may not:</p>
              <ul className="list-disc list-inside space-y-1.5 ml-2">
                <li>Use the website in any way that violates applicable laws or regulations</li>
                <li>Attempt to gain unauthorized access to any part of the website</li>
                <li>Use automated systems to scrape or extract data from the website</li>
                <li>Transmit any harmful or malicious content</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">4. Intellectual Property</h2>
              <p>All content on this website, including text, graphics, logos, images, and software, is the property of Apex Fit Sales Coaching and is protected by intellectual property laws. You may not reproduce, distribute, or create derivative works without our express written permission.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">5. Limitation of Liability</h2>
              <p>To the fullest extent permitted by law, Apex Fit Sales Coaching shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our website or services. Our total liability shall not exceed the amount paid by you for the specific service giving rise to the claim.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">6. Confidentiality</h2>
              <p>Both parties agree to maintain the confidentiality of any proprietary or sensitive information shared during the course of our business relationship. This obligation survives the termination of any agreement between us.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">7. Exclusivity Agreement</h2>
              <p>As part of our commitment to your success, we only work with one gym per local area. This exclusivity ensures we can provide dedicated support without conflicts of interest.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">8. Changes to Terms</h2>
              <p>We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately upon posting to the website. Your continued use of the website constitutes acceptance of the modified terms.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">9. Contact Us</h2>
              <p>If you have any questions about these Terms of Service, please contact us at <a href="mailto:kyran@apexfitsalescoaching.com" className="text-[#22C55E] hover:underline">kyran@apexfitsalescoaching.com</a>.</p>
            </section>
          </div>
        </div>
      </main>
      <ApexFooter />
    </div>
  );
};

export default TermsOfService;
